export default __webpack_public_path__ + "static/media/food-beverage.e2689770.png";